import { ApolloClient } from '@apollo/client';
import { parse } from '@jupiterone/query-language-parser';
import { DeferredJ1QL } from '@jupiterone/jupiter-web-toolkit/src/graphql/queries/J1';
import fetchQueryJobStatus from '@jupiterone/jupiter-web-toolkit/src/util/fetchQueryJobStatus';
import isAQuery from '@jupiterone/jupiter-web-toolkit/src/util/isAQuery';
import {
  DeferredQueryInput,
  DeferredQueryResponse,
  QueryV1Input,
} from '@jupiterone/jupiter-web-toolkit/types/J1QL';

export const formatDeferredQuery = (query: string) => {
  const formattedQuery = query.trim();

  if (!isAQuery(formattedQuery)) {
    return `"${formattedQuery}"`;
  }
  return formattedQuery;
};

export const deferredQuery = async (
  apolloClient: ApolloClient<any>,
  { ...queryInput }: DeferredQueryInput
): Promise<DeferredQueryResponse> => {
  if (!queryInput.query) {
    throw new Error('No query provided');
  }

  const query = formatDeferredQuery(queryInput.query);

  if (!parse(query)) {
    throw new Error('Unable to parse J1QL query');
  }

  try {
    const deferredResult = await initiateDeferredQuery({
      apolloClient,
      queryInput: {
        ...queryInput,
        query,
      },
    });

    if (!deferredResult.url) {
      throw new Error('No state file returned by queryV1 deferred.');
    }

    const dataUrl = await fetchQueryJobStatus({
      pollFrequency: 2500,
      stateFileUrl: deferredResult.url,
    });

    return { url: dataUrl };
  } catch (error) {
    throw new Error(`Error loading result for query: ${query}`);
  }
};

interface InitiateDeferredQueryInput {
  apolloClient: ApolloClient<any>;
  queryInput: QueryV1Input;
}

async function initiateDeferredQuery({
  apolloClient,
  queryInput,
}: InitiateDeferredQueryInput) {
  // hit old queryV1 graphql api
  const result = await apolloClient.query<{ queryV1: any }>({
    query: DeferredJ1QL,
    variables: queryInput,
    fetchPolicy: 'no-cache',
  });

  return result.data?.queryV1;
}
